function SearchFeedbackError({ message, options = {} }) {
  const config = Object.entries(options)
    .filter(([option, value]) => value !== undefined)
    .reduce(
      (obj, [option, value]) => {
        obj[option] = value;
        return obj;
      },
      {
        error_message: `Ops, não foi possível concluir a sua pesquisa. Tente novamente!`,
        error_expose: false,
      }
    );

  return (
    <div className="bn-search__results-header">
      {config.error_message}
      {config.error_expose ? <span>Erro: {message}</span> : null}
    </div>
  );
}

export default SearchFeedbackError;
